import { useEffect } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import {
  environmentDomainsSelector,
  environmentDomainsLoadingSelector
} from "Reducers/project/settings/environmentDomains/environmentDomains.selectors";
import { getEnvironmentDomainsThunk } from "Reducers/project/settings/environmentDomains/thunks/getEnvironmentDomains.thunk";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import type { Environment, Project } from "@packages/client";

export const useLoadEnvironmentDomains = (
  environment?: Environment,
  project?: Project
) => {
  const dispatch = useAppDispatch();
  const { projectId } = useDecodedParams<{
    projectId: string;
  }>();

  const environmentDomains = useAppSelector(state =>
    environmentDomainsSelector(state, { projectId })
  );

  const loading = useAppSelector(state =>
    environmentDomainsLoadingSelector(state, { projectId })
  );

  useEffect(() => {
    if (project?.id && project.subscription?.plan !== "development") {
      dispatch(getEnvironmentDomainsThunk({ project, environment }));
    }
  }, [dispatch, environment, project]);

  return {
    environmentDomains: environmentDomains
      ? [...environmentDomains]
      : undefined,
    loading
  };
};
